/**
 * @generated SignedSource<<a8c68b1386fb02ff362f2bcf76511544>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useEmojiEverSetPropertyFragment_content$data = Result<{
  readonly id: string | null;
  readonly properties: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useEmojiEverSetPropertyFragment_content";
}, unknown>;
export type useEmojiEverSetPropertyFragment_content$key = {
  readonly " $data"?: useEmojiEverSetPropertyFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEmojiEverSetPropertyFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEmojiEverSetPropertyFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "emoji-ever-set"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ],
      "storageKey": "properties(key:\"emoji-ever-set\")"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "8ee870b36d56474c05ddcf83842fb05a";

export default node;
